import React from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "convex/react";
import { useContext } from "react";
import { api } from "../../../../convex/_generated/api";
import { Id } from "../../../../convex/_generated/dataModel";
import { MainRoutes } from "../../../../shared/models";
import { BaseContext } from "../../../../shared/base-context";

interface ActionButton {
  label: string;
  action: string; // "start_session" | "navigate" | "submit_prompt"
  payload: Record<string, string>;
}

interface Props {
  data: {
    buttons: ActionButton[];
  };
}

export const ActionButtonsWidget: React.FC<Props> = ({ data }) => {
  const navigate = useNavigate();
  const { convexUserId } = useContext(BaseContext);
  const startSession = useMutation(api.sessions.startSession);

  const handleButtonClick = async (button: ActionButton) => {
    switch (button.action) {
      case "start_session":
        if (convexUserId && button.payload.session_id) {
          try {
            const result = await startSession({
              user_id: convexUserId as Id<"users">,
              assistant_id: button.payload.session_id as Id<"assistants">,
            });
            if (result?.session_id) {
              navigate(`${MainRoutes.Chat}?sessionId=${result.session_id}`);
            }
          } catch (error) {
          }
        }
        break;

      case "navigate":
        if (button.payload.path) {
          navigate(button.payload.path);
        }
        break;

      case "submit_prompt":
        // This would need to be handled by the parent component
        // For now, just log it
        break;

      default:
    }
  };

  if (!data?.buttons || data.buttons.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2 mt-2">
      {data.buttons.map((button, index) => (
        <button
          key={index}
          onClick={() => handleButtonClick(button)}
          className="px-4 py-2 bg-primary text-white text-sm rounded-full hover:bg-primary/90 transition-all shadow-sm"
        >
          {button.label}
        </button>
      ))}
    </div>
  );
};
